<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LQGq5P/tc-custom/9781488060458.jpg?1725275240811" alt="This image is the cover for the book Cowboy's Christmas Blessings, Wyoming Sweethearts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cowboy's Christmas Blessings, Wyoming Sweethearts
      </h1>
      <p class="bookDescription body article font2">
        <b>In this Christian holiday romance, a lonely Wyoming rancher receives the gift of family when he welcomes a widowed mother into his home for Christmas.</b><br/><br/>Judd Wilson lives a solitary life . . . until he learns Nicole Taylor and her infant triplets need somewhere to stay. The cabin on his ranch is the perfect solution, but now his quiet Christmas alone feels a lot more crowded. Recently widowed, Nicole questions her swiftly developing feelings for Judd, even if the older man is wonderful with her babies. Is she ready to take that leap again?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill Kemerer
      </h2>
      
      <p class="authorDescription body article"><B>Jill Kemerer </B>is a Publishers Weekly bestselling author of Christian romance novels. Her essentials include coffee, a stack of books, her mini-dachshund, and taking long nature walks. Jill resides in Ohio with her husband and two almost-grown children. She loves connecting with readers, so please visit her website, jillkemerer.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?510203fe